"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Opt {
    get(fieldname) {
        return this[fieldname] ? this[fieldname] : undefined;
    }
}
exports.Opt = Opt;
//# sourceMappingURL=opt.js.map